import EmptyFail from '@digital-retail/ui-common/components/EmptyFail';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { DynamicBanner } from '../containers/NoResults/DynamicBanner/DynamicBanner';
import { InformationBox } from '../containers/NoResults/InformationBox/InformationBox';
import { NoResultsStyles } from '../containers/NoResults/NoResults.style';
import { withApplicationContext } from '../utils/ApplicationContext';
import { redirectToUrl } from '../utils/RouteHandler';
import { WithUrl } from '../utils/WithUrl';

const isInternalServerError = (statusCode) => {
  return statusCode.toString().indexOf('5') === 0;
};

const shouldRedirectError = (url, statusCode) => {
  return url && !isInternalServerError(statusCode);
};

class Error extends Component {
  static getInitialProps({ appCtx }, { res, err, query }) {
    const site = (query && query.site) || '-';
    const isImageSearch = query?.isImageSearch ?? false;
    const regionCode = site.split('-')[1];
    const statusCode = (res && res.statusCode) || (err && err.statusCode) || 500;
    const url = WithUrl(statusCode, regionCode);
    if (shouldRedirectError(url, statusCode)) {
      return redirectToUrl(url, res);
    }
    return {
      appCtx,
      isImageSearch,
    };
  }

  componentDidMount() {
    const { appCtx } = this.props;
    if (appCtx) {
      appCtx.setBusy(false);
    }
  }

  render() {
    const { appCtx, isImageSearch } = this.props;
    const errorLabel = {
      error: { failText1: 'Ocurrió un error', failText2: 'Por favor, intenta nuevamente.' },
      noResult: {
        noProductsText1: 'No encontramos resultados',
        noProductsText2: 'Intenta con otra imagen o busca en las categorías.',
      },
    };
    const labels = appCtx?.siteConfig?.textDictionary ?? {};
    return (
      <div className="no-result error-page">
        <div className="container">
          {isImageSearch ? (
            <EmptyFail isError labels={errorLabel} />
          ) : (
            <InformationBox title={labels.PAGE_ERROR_TITLE} />
          )}
          <DynamicBanner url={WithUrl('BANNER_MC', appCtx.regionCode)} />
          <DynamicBanner url={WithUrl('CATEGORY_BANNER', appCtx.regionCode)} />
        </div>
        <style jsx>{NoResultsStyles}</style>
      </div>
    );
  }
}

Error.defaultProps = {
  isImageSearch: false,
};

Error.propTypes = {
  appCtx: PropTypes.object.isRequired,
  isImageSearch: PropTypes.bool,
};

export { Error, isInternalServerError, shouldRedirectError };
export default withApplicationContext(Error);
